/* tslint:disable */
/* eslint-disable */
export enum Type {
  TravelInsurance = 'TRAVEL_INSURANCE',
  CreditCard = 'CREDIT_CARD'
}
